'use strict';
const angular = require('angular');
var currentStation;
var jurisdiction;
var submissionPolicies = [];
var tierOverrideStations = [
  'Belmont Caltrain',
  'Bayshore Caltrain',
  'Lafayette BART',
  'Orinda BART',
  'San Carlos Caltrain'
]

 // Define the UUID template with placeholder characters
 var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";

/*@ngInject*/
export function lookupService() {
  this.getCurrentStation = function () {
    return currentStation;
  };

  this.setCurrentStation = function (station) {
    currentStation = station;
  };

  this.getJurisdiction = function () {
    return jurisdiction;
  };

  this.setJurisdiction = function (juris) {
    jurisdiction = juris;
  };

  this.getSubmissionPolicies = function () {
    return submissionPolicies;
  };

  this.setSubmissionPolicies = function (policies) {
    submissionPolicies = policies;
  };

  this.getUUID = function(){
    
      // Get current time in milliseconds
      var d = new Date().getTime();
   
     
   
      // Replace the placeholders with random hexadecimal digits
      uuid = uuid.replace(/[xy]/g, function(c) {
          // Generate a random number between 0 and 15
          var r = (d + Math.random()*16)%16 | 0;
   
          // Update value of d for the next placeholder
          d = Math.floor(d/16);
   
          // Convert the number to a hexadecimal digit and return it
          return (c=="x" ? r : (r&0x3|0x8)).toString(16);
      });
   
      return uuid;

    
  }

  this.getOverrideStations = function () {
    return tierOverrideStations;
  };
}

export default angular.module('appApp.lookup', [])
  .service('lookup', lookupService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/lookup/lookup.service.js